angular.module('mobilezuz')
    .directive('spPointRedemption', function() {
        return {
            restrict: 'E',
            templateUrl: 'views/templates/sp-point-redemption.html',
            replace: true,
            controller: ['$scope', 'User', 'Config', '$rootScope', 'Api', '$timeout', '$state', 'Util', 'Retailer', 'LOYALTY_PAGE_METHODS', 'LOYALTY_CLUB_DRIVERS', 'Loyalty', 'Coupon',
            function($scope, User, Config, $rootScope, Api, $timeout, $state, Util, Retailer, LOYALTY_PAGE_METHODS, LOYALTY_CLUB_DRIVERS, Loyalty, Coupon) {
                var  _timeoutOpenMenuPages;
                var userData;
                setNumberOfCoupons();
                setUser();
                setLoyaltyPageConfig();

                var _listeners = [];

                _listeners.push($scope.$watch(function() {
                    return Config.language.culture;
                }, function(newCulture, oldCulture) {
                    $scope.language = newCulture;
                }));

                function setUser() {
                    User.getData().then(function(data) {
                        $scope.user = data;
                        userData = data;
                        $scope.loyaltyClub = data.loyaltyClubs.find(function(item) {
                            if (!Config || !Config.retailer || !Config.retailer.loyaltyClubDriver || !Config.retailer.loyaltyClubDriver.clientConfig || !Config.retailer.loyaltyClubDriver.clientConfig.loyaltyClubs || !Config.retailer.loyaltyClubDriver.loyaltyClubIds) {
                                return;
                            }
                            return item.loyaltyClubDriverId === Config.retailer.loyaltyClubDriver.loyaltyClubDriverId && Config.retailer.loyaltyClubDriver.loyaltyClubIds.includes(item.loyaltyClubId) && Config.retailer.loyaltyClubDriver.clientConfig.loyaltyClubs[item.loyaltyClubId].pointsToCashback === true;
                        })
                        if ($scope.loyaltyClub) {
                            Util.getUserCashbackPoints($scope.loyaltyClub.id).then(function (response) {
                                $scope.userPoints = response.points || 0;
                            });
                        }
                        setLoyaltyPageConfig(userData);
                        setNumberOfCoupons()
                    });
                }
                
                function setLoyaltyPageConfig(userData) {
                    var loyaltyClubDriver;
                    if (userData && userData.loyaltyClubs.length > 0) {
                        var userCashbackLoyalty = userData.loyaltyClubs && userData.loyaltyClubs.length && userData.loyaltyClubs.find(function(club) {
                            return Loyalty.isCashbackLoyaltyClub(club.loyaltyClubId);
                        });
                        loyaltyClubDriver = Loyalty.getLoyaltyDriver(userCashbackLoyalty.loyaltyClubDriverId)
                        $scope.loyaltyClubDriver = loyaltyClubDriver;
                        if (loyaltyClubDriver && loyaltyClubDriver.clientConfig && loyaltyClubDriver.clientConfig.loyaltyClubs) {
                            Loyalty.getSpecialsLoyalty($scope.loyaltyClubDriver.loyaltyClubIds, 0).then(function(data) {
                                $scope.numberOfSpecials = data.total
                            })
                            var loyaltyClub = loyaltyClubDriver.clientConfig.loyaltyClubs[$scope.loyaltyClub.loyaltyClubId]
                            $scope.cashbackRatio = loyaltyClub.pointsToCashbackRatio
                            $scope.loyaltyHomepageConfig = loyaltyClub.loyaltyPages.homepage
                            $scope.isHomepageActive = loyaltyClub.loyaltyPages.homepage.isActive
                            $scope.pointsToRedeemCashback = loyaltyClub.minPointsNum;
                            $scope.pointName = loyaltyClub.loyaltyPages.visibility.tex;
                        }
                    }
                    if ((userData == undefined || userData && userData.loyaltyClubs.length == 0) && Config.retailer && Config.retailer.loyaltyClubDriver && Config.retailer.loyaltyClubDriver.clientConfig && Config.retailer.loyaltyClubDriver.clientConfig.loyaltyClubs !== undefined && Object.values(Config.retailer.loyaltyClubDriver.clientConfig.loyaltyClubs).length > 0) {
                        var loyaltyClubs = Object.values(Config.retailer.loyaltyClubDriver.clientConfig.loyaltyClubs);
                        if (loyaltyClubs.length > 0 && loyaltyClubs[0].loyaltyPages && loyaltyClubs[0].loyaltyPages.homepage) {
                            $scope.loyaltyHomepageConfig = loyaltyClubs[0].loyaltyPages.homepage
                            $scope.isHomepageActive = loyaltyClubs[0].loyaltyPages.homepage.isActive
                        }
                    }
                }
    
                $rootScope.$on('numberOfCouponsRoot', function(event, data) {
                    $scope.numberOfCoupons = data
                })
                
                $rootScope.$on('login', function() {
                    User.getData().then(function(data) {
                        $scope.user = data
                        userData = data;
                        $scope.loyaltyClub = data.loyaltyClubs.find(function(item) {
                            if (!Config || !Config.retailer || !Config.retailer.loyaltyClubDriver || !Config.retailer.loyaltyClubDriver.clientConfig || !Config.retailer.loyaltyClubDriver.clientConfig.loyaltyClubs || !Config.retailer.loyaltyClubDriver.loyaltyClubIds) {
                                return;
                            }
                            return item.loyaltyClubDriverId === Config.retailer.loyaltyClubDriver.loyaltyClubDriverId && Config.retailer.loyaltyClubDriver.loyaltyClubIds.includes(item.loyaltyClubId) && Config.retailer.loyaltyClubDriver.clientConfig.loyaltyClubs[item.loyaltyClubId].pointsToCashback === true;
                        })
                        if ($scope.loyaltyClub) {
                            Util.getUserCashbackPoints($scope.loyaltyClub.id).then(function (response) {
                                $scope.userPoints = response.points || 0;
                            });
                        }
                        setLoyaltyPageConfig(data);
                        setNumberOfCoupons();
                    })
                })
                
                function setNumberOfCoupons() {
                    if (
                        userData &&
                        $rootScope.config.retailer.settings.enablePersonalizedCoupons
                    ) {
                        Coupon.getNumberOfCoupons()
                            .then(function (couponsData) {
                                var coupons = couponsData.coupons || couponsData;
                                $scope.numberOfCoupons = coupons.length;
                        });
                    } else {
                        delete $scope.numberOfCoupons;
                    }
                }

                $scope.openLoyaltyMembershipPages = function (stateName, stateParams) {
                    if (_timeoutOpenMenuPages) {
                        $timeout.cancel(_timeoutOpenMenuPages);
                    }
                    _timeoutOpenMenuPages = $timeout(function () {
                        $state.go(stateName, stateParams);
                    }, 300);
                };

                function _setRetailerData(withoutCache) {
                    return User.getRetailerData(withoutCache).then(function (retailerData) {
                        $scope.loyaltyClubDrivers = retailerData.loyaltyClubDrivers;
                        $scope.isLoyaltyExtendedRegisterActive = retailerData.loyaltyClubDrivers.length === 1 &&  retailerData.loyaltyClubDrivers[0].clientConfig &&  retailerData.loyaltyClubDrivers[0].clientConfig.extendedLoyaltyClub;
                        $scope.retailerData = retailerData;
                    });
                }
                _setRetailerData();

                if (userData == undefined) { 
                    $scope.goToLoginDialog = function(event) {
                        event.stopPropagation();
                        Util.goToLoginDialog();
                    }
                }

                $scope.goToSignInMembership = function(event) {
                    event.stopPropagation();
                    $state.go('app.extendedLoyaltyClub');
                }

                $rootScope.$on('logout', function () {
                    delete $scope.isHomepageActive;
                    delete $scope.user;
                    setLoyaltyPageConfig();
                })
                
                Util.destroyListeners($scope, _listeners);
            }]
        };
    });